"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Button = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _getClassesPropType = require("../../helpers/getClassesPropType");

var _useStyles = require("../../helpers/useStyles");

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = require("prop-types");

var _loadStyles = _interopRequireDefault(require("load-styles"));

var _excluded = ["children", "view", "size", "classes"];
(0, _loadStyles.default)(".c26bf8ab0{outline:0;background:0 0;border:0;color:inherit;font:inherit;line-height:normal;overflow:visible;padding:0;-webkit-user-select:none;-ms-user-select:none;user-select:none;text-transform:capitalize;max-width:100%;box-sizing:border-box;position:relative;z-index:0;font-size:.875rem;font-weight:500;line-height:1.25rem;white-space:nowrap;text-overflow:ellipsis;overflow:hidden}.c26bf8ab0:after{content:'';transition:all var(--animation-timing-def) ease;transition-property:opacity,background;top:0;left:0;bottom:0;right:0;position:absolute;z-index:-1}.c26bf8ab0:not(.c84a8c05b){cursor:pointer}.c26bf8ab0:not(.c84a8c05b):hover:after{opacity:.7}.c26bf8ab0:not(.c84a8c05b):active:after{opacity:.5}.cf7117268{padding:.75rem 1.25rem;border-radius:.313rem}.c0b4b930d{padding:.5rem 1rem;border-radius:.313rem}.c9484479f{padding:.25rem .75rem;border-radius:.125rem}.c51b33379{color:#fff}.c51b33379:after{background:var(--color-flomni-blue-70)}.cab3adbd3{color:var(--color-flomni-blue-70)}.cab3adbd3:after{background:var(--color-flomni-blue-10)}.c133d53fa{color:var(--color-flomni-rose-70)}.c133d53fa:after{background:var(--color-flomni-rose-10)}.c317c161a{color:var(--color-flomni-gray-90)}.c317c161a:after{background:var(--color-flomni-yellow-50)}.c74377a44{color:var(--color-flomni-gray-70)}.c74377a44:after{background:0 0}.c2ede3331{color:var(--color-flomni-blue-70)}.c2ede3331:after{background:var(--color-flomni-white)}.c84a8c05b:not(.c74377a44){color:var(--color-flomni-gray-50)}.c84a8c05b:not(.c74377a44):after{background:var(--color-flomni-gray-10)}");
var styles = {
  root: 'c26bf8ab0',
  '--disabled': 'c84a8c05b',
  '--size-default': 'cf7117268',
  '--size-medium': 'c0b4b930d',
  '--size-small': 'c9484479f',
  '--view-primary': 'c51b33379',
  '--view-secondary': 'cab3adbd3',
  '--view-warning': 'c133d53fa',
  '--view-bright': 'c317c161a',
  '--view-cancel': 'c74377a44',
  '--view-white': 'c2ede3331'
};

var Button = function Button(props) {
  var children = props.children,
      view = props.view,
      size = props.size,
      classes = props.classes,
      rest = (0, _objectWithoutProperties2.default)(props, _excluded);
  var disabled = rest.disabled;
  var cn = (0, _useStyles.useStyles)(styles, classes);
  return /*#__PURE__*/_react.default.createElement("button", (0, _extends2.default)({
    className: (0, _classnames.default)(cn.root, cn.view[view], cn.size[size], (0, _defineProperty2.default)({}, cn.disabled, disabled))
  }, rest), children);
};

exports.Button = Button;
var view = ['primary', 'secondary', 'warning', 'bright', 'white', 'cancel'];
var size = ['default', 'medium', 'small'];
Button.modes = {
  view: view,
  size: size
};
Button.propTypes = {
  /* component logic props */
  children: _propTypes.node.isRequired,
  disabled: _propTypes.bool,

  /* styling modificators */
  view: (0, _propTypes.oneOf)(view),
  size: (0, _propTypes.oneOf)(size),

  /* classes */
  classes: (0, _getClassesPropType.getClassesPropType)(styles)
};
Button.defaultProps = {
  view: 'secondary',
  size: 'default',
  classes: {},
  disabled: false
};